export class GA4 {
  /**
   * Push event each time a diagnostics search is performed
   */
  static searchEvent() {
    const gtag = (window as any).gtag as any;
    if (gtag !== undefined) {
      gtag('event', 'diagnostics_search');
    }
  }
}
